<app-navbar></app-navbar>
<app-sidenav></app-sidenav>
<app-tour></app-tour>
